// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { chain, ExecuteOnErrorCallback } from "@insite/client-framework/Store/Data/WishLists/Handlers/AddToWishList";
import { xGoogleAnalyticsState } from "@west/App/Store/Reducers";
import { getDataLayer } from "@west/XDL/Utilities/tracking";

export const GaSendTracking: typeof ExecuteOnErrorCallback = props => {
    const state = props.getState() as xGoogleAnalyticsState;
    if (state.xGoogleAnalytics.addToWishListEvent) {
        const items = props.parameter.productInfos.map((productInfo, index) => ({
            index,
            item_id: productInfo.productId,
            qtyOrdered: productInfo.qtyOrdered,
            unitOfMeasure: productInfo.unitOfMeasure,
            price: productInfo.pricing?.unitNetPrice,
            affiliation: state.xGoogleAnalytics.affiliation,
            item_list_name: props.result.wishList?.name,
            item_list_id: props.result.wishList?.id,
        }));

        const dataLayer = getDataLayer();

        if (!dataLayer) {
            return;
        }

        const session = getSession(state);

        const googleAnalyticsData = {
            event: state.xGoogleAnalytics.addToWishListEventName,
            ecommerce: {
                value: Number(
                    items
                        .reduce((total, item) => {
                            return total + (item?.price || 0);
                        }, 0)
                        ?.toFixed(2),
                ),
                currency: session.currency?.currencyCode,
                affiliation: state.xGoogleAnalytics.affiliation,
                authentication_state: state.xGoogleAnalytics.authenticationState,
                items,
            },
        };

        dataLayer.push(googleAnalyticsData);
        dataLayer.push({ ecommerce: null });
    }
};

addToEndOfChain(chain, GaSendTracking);
